export const CONTACTS_TABLE_NAME = "contacts_table";
